import { SVGProps } from 'react'

export const Liked = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" {...props}>
    <g>
      <path
        fill="currentColor"
        d="M10 17.646l-1.209-1.1C4.5 12.654 1.666 10.087 1.666 6.937c0-2.566 2.017-4.583 4.584-4.583A4.99 4.99 0 0110 4.096a4.99 4.99 0 013.75-1.742c2.567 0 4.583 2.017 4.583 4.583 0 3.15-2.833 5.717-7.125 9.617L10 17.646z"
      ></path>
    </g>
  </svg>
)
